import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLogin = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.869 4.313A4.4 4.4 0 0 1 12 3c1.175 0 2.301.472 3.132 1.313a4.5 4.5 0 0 1 1.297 3.169 4.5 4.5 0 0 1-1.297 3.17A4.4 4.4 0 0 1 12 11.963a4.4 4.4 0 0 1-3.131-1.313 4.5 4.5 0 0 1-1.298-3.17A4.5 4.5 0 0 1 8.87 4.314M12 4.735c-.72 0-1.41.29-1.92.805a2.76 2.76 0 0 0-.794 1.942c0 .728.286 1.427.795 1.942.509.516 1.2.805 1.919.805s1.41-.29 1.92-.805a2.76 2.76 0 0 0 .794-1.942c0-.729-.286-1.427-.795-1.942A2.7 2.7 0 0 0 12 4.735M5.297 15.156a4.4 4.4 0 0 1 3.132-1.313h7.142c1.175 0 2.301.473 3.132 1.313A4.5 4.5 0 0 1 20 18.326v1.806c0 .48-.384.868-.857.868a.86.86 0 0 1-.857-.867v-1.808c0-.728-.286-1.427-.795-1.942a2.7 2.7 0 0 0-1.92-.805H8.43c-.72 0-1.41.29-1.92.805a2.76 2.76 0 0 0-.795 1.942v1.808c0 .479-.383.867-.857.867A.86.86 0 0 1 4 20.133v-1.808a4.5 4.5 0 0 1 1.297-3.169"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLogin;
